import { useTranslation } from 'react-i18next';
import { fetchExcel, fetchNextDayExcel } from './MenuTodayService';
import { useAlert } from 'react-alert';
import { FileExtension, saveFile } from '../../../../components/common/FileUtils';
import { getTodayDate, getTodayPlusDays } from '../../../../utils/TimeUtils';
import { DownloadButton } from '../../../../components/buttons/DownloadButton';
import './PeopleDeclaration.css';
import { PeopleDeclarationForm } from './declaration/PeopleDeclarationForm';

export const MenuTodayActions = () => {

    const { t } = useTranslation('monthMenu');
    const alert = useAlert();

    const downloadExcel = () => {
        fetchExcel()
            .then((response) => {
                let fileName = t('headers:todayMenu') + '-' + getTodayDate();
                saveFile(response.data, fileName, FileExtension.XLS);
            })
            .catch(() => alert.error(t('alert:loadingError')));
    };

    const downloadNextDayExcel = () => {
        fetchNextDayExcel()
            .then((response) => {
                let fileName = t('headers:todayMenu') + '-' + getTodayPlusDays(1);
                saveFile(response.data, fileName, FileExtension.XLS);
            })
            .catch(() => alert.error(t('alert:loadingError')));
    };

    return (
        <>
            <div className={'menu-today-dietist-panel'}>
                <PeopleDeclarationForm></PeopleDeclarationForm>
                <div className={'center'}>
                    <DownloadButton onClick={downloadExcel}
                                    tooltip={t('todayMenu:downloadTooltip')}
                                    title={FileExtension.XLS}>
                    </DownloadButton>
                    <DownloadButton onClick={downloadNextDayExcel}
                                    title={t('todayMenu:nextDay') + ' ' + FileExtension.XLS}>
                    </DownloadButton>
                </div>
            </div>
        </>
    );
};